import React, {useState} from "react";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Input from "@amzn/meridian/input";
import get from "lodash/get";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import {addToObject} from "../util/CommonUtils";
import {
    INCLUDED_LOCATION_OPTIONS,
    SortGridAllocationCommonFormStates
} from "../../Constants";
import RadioButton from "@amzn/meridian/radio-button";
import {inputType} from "../../enums";
import {FeatureConfigUtils} from "../util/FeatureConfigUtils";
import SelectOption from "@amzn/meridian/select/select-option";
import Select from "@amzn/meridian/select";


const SortGridAllocationPartitionInputForm = (props) => {
    const {
        commonFormInputs: {resourceTemperatureInputs, isPSOnGridSortPathInputs, isGroceryBinSortPathInputs, includedLocationInputs, excludedLocationInputs, resourceVolumeTypeInputs, isRushSortPathInputs, isRush3hSortPathInputs}, commonFormData, addToCommonFormData,
        isNewGridAllocation
    } = props;

    const [showTemperatureOption, setShowTemperatureOption] = useState(false);
    const includedLocations = get(commonFormData, [SortGridAllocationCommonFormStates.INCLUDED_LOCATIONS]);
    const excludedLocations = get(commonFormData, [SortGridAllocationCommonFormStates.EXCLUDED_LOCATIONS]);
    const additionalParams = get(commonFormData, SortGridAllocationCommonFormStates.ADDITIONAL_PARAMS);
    const isGrocerySortPath = get(commonFormData, SortGridAllocationCommonFormStates.IS_GROCERY_SORT_PATH);
    const isPSOnGridSortPath = get(commonFormData, SortGridAllocationCommonFormStates.IS_PS_ON_GRID_SORT_PATH);
    const isRushSortPath = get(commonFormData, SortGridAllocationCommonFormStates.IS_RUSH_SORT_PATH);
    const isRush3hSortPath = get(commonFormData, SortGridAllocationCommonFormStates.IS_RUSH_3H_SORT_PATH);

    const renderExcludedLocationsInputForm = () => {
        return (
            <Row>
                { excludedLocationInputs.map(input => {
                    return (
                        <Row key={input.id}>
                            <Column spacing={"small"}>
                                <Row>
                                    <Text type={"h100"}>
                                        <FormattedMessage id={input.formattedId} defaultMessage={input.defaultLabel}/>:
                                    </Text>
                                </Row>
                                <Row>
                                    <Input value={get(excludedLocations, [input.id])}
                                           data-testid={input.id}
                                           disabled={!props.isAuthorized}
                                           onChange={ value => addToCommonFormData(SortGridAllocationCommonFormStates.EXCLUDED_LOCATIONS,
                                               addToObject(excludedLocations, input.id, value)
                                           )}
                                           placeholder={input.placeholder}
                                           type="text" />
                                </Row>
                            </Column>
                        </Row>
                    )
                })}
            </Row>
        );
    }

    const disableCustomInputOption = (inputOptionId) => {
        return (isGrocerySortPath && (inputOptionId === "sortLocationsRangeCustom" || inputOptionId === "specifySortLocationsRange")) 
                    || ((isRushSortPath || isRush3hSortPath) && (inputOptionId === "sortLocationsRangeUseAll"));
    }
    const renderIncludedLocationInputOption = (includedLocationOptions, inputOption) => {
        switch (inputOption.inputType) {
            case inputType.RADIO:
                return (<Row key={inputOption.id}>
                    <RadioButton checked={get(includedLocations, [includedLocationOptions.id, 0]) === inputOption.value
                        && !disableCustomInputOption(inputOption.id)}
                                 onChange={value => addToCommonFormData(
                                     SortGridAllocationCommonFormStates.INCLUDED_LOCATIONS,
                                     addToObject(includedLocations, includedLocationOptions.id, [value, inputOption.customValue])
                                 )}
                                 name={inputOption.id}
                                 disabled={!props.isAuthorized || disableCustomInputOption(inputOption.id)}
                                 value={inputOption.value}>
                        <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                    </RadioButton>
                </Row>);
            case inputType.TEXT:
                return (<Row key={inputOption.id}>
                    <Text type={"h100"}>
                        <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                    </Text>
                    <Input value={get(includedLocations, [includedLocationOptions.id, 1])}
                           onChange={value => addToCommonFormData(
                               SortGridAllocationCommonFormStates.INCLUDED_LOCATIONS,
                               addToObject(includedLocations, includedLocationOptions.id, [inputOption.value, value])
                           )}
                           placeholder={inputOption.placeholder}
                           type="text"
                           disabled={!props.isAuthorized || get(includedLocations, [includedLocationOptions.id, 0]) !== INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM
                               || disableCustomInputOption(inputOption.id)}
                    />
                </Row>);
            default:
                return null;
        }
    }

    const renderIncludedLocationInput = (includedLocationOptions) => {
        return (
            <Row key={includedLocationOptions.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={includedLocationOptions.formattedId}
                                              defaultMessage={includedLocationOptions.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { includedLocationOptions.inputOptions
                            .map(inputOption => renderIncludedLocationInputOption(includedLocationOptions, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

    const renderResourceTemperatureInputOption = (temperatureOptions, inputOption) => {
        return (
            <Column key={inputOption.id}>
                <Row spacing={"small"}>
                    <Column>
                        <RadioButton
                            checked={get(additionalParams, temperatureOptions.id) === inputOption.value}
                            onChange={value => addToCommonFormData(
                                SortGridAllocationCommonFormStates.ADDITIONAL_PARAMS,
                                addToObject(additionalParams, temperatureOptions.id, value)
                            )}
                            name={inputOption.id}
                            value={inputOption.value}
                            disabled={!props.isAuthorized || !isNewGridAllocation}
                        >
                            <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                        </RadioButton>
                    </Column>
                </Row>
            </Column>
        );
    }

    const renderResourceTemperatureInput = (temperatureOptions) => {
        return (
            <Row key={temperatureOptions.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={temperatureOptions.formattedId}
                                              defaultMessage={temperatureOptions.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { temperatureOptions.inputOptions
                            .map(inputOption => renderResourceTemperatureInputOption(temperatureOptions, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

    const renderResourceVolumeTypeInput = (volumeTypeOptions) => {
        return (
            <Row key={volumeTypeOptions.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={volumeTypeOptions.formattedId}
                                              defaultMessage={volumeTypeOptions.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        <Select
                            size="medium"
                            width={250}
                            disabled={!isNewGridAllocation}
                            placeholder="Enter Volume Type"
                            value={get(commonFormData, [SortGridAllocationCommonFormStates.VOLUME_TYPE])}
                            onChange={value =>
                                {
                                    addToCommonFormData(SortGridAllocationCommonFormStates.VOLUME_TYPE, value)
                                }
                            }
                        >
                            {volumeTypeOptions.inputOptions.map(inputOption =>
                                <SelectOption key={inputOption.id} value={inputOption.value} label={inputOption.defaultLabel} />
                            )}
                        </Select>
                    </Row>

                </Column>
            </Row>
        )
    }

    const renderIsGrocerySortPathInputOption = (option, inputOption) => {
        return (
            <Column key={inputOption.id}>
                <Row spacing={"small"}>
                    <Column>
                        <RadioButton
                            checked={isGrocerySortPath === inputOption.value}
                            onChange={value => {
                                    setShowTemperatureOption(inputOption.value);
                                    addToCommonFormData(
                                    SortGridAllocationCommonFormStates.IS_GROCERY_SORT_PATH,
                                    value
                                )
                                }
                            }
                            name={inputOption.id}
                            value={inputOption.value}
                            disabled={!props.isAuthorized || !isNewGridAllocation || isPSOnGridSortPath}
                        >
                            <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                        </RadioButton>
                    </Column>
                </Row>
            </Column>
        );
    }

    const renderIsRushSortPathInputOption = (option, inputOption) => {
        return (
            <Column key={inputOption.id}>
                <Row spacing={"small"}>
                    <Column>
                        <RadioButton
                            checked={isRushSortPath === inputOption.value}
                            onChange={value => {
                                    addToCommonFormData(
                                    SortGridAllocationCommonFormStates.IS_RUSH_SORT_PATH,
                                    value
                                )
                                }
                            }
                            name={inputOption.id}
                            value={inputOption.value}
                            disabled={!props.isAuthorized || !isNewGridAllocation}
                        >
                            <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                        </RadioButton>
                    </Column>
                </Row>
            </Column>
        );
    }

        const renderIsRush3hSortPathInputOption = (option, inputOption) => {
        return (
            <Column key={inputOption.id}>
                <Row spacing={"small"}>
                    <Column>
                        <RadioButton
                            checked={isRush3hSortPath === inputOption.value}
                            onChange={value => {
                                    addToCommonFormData(
                                    SortGridAllocationCommonFormStates.IS_RUSH_3H_SORT_PATH,
                                    value
                                )
                                }
                            }
                            name={inputOption.id}
                            value={inputOption.value}
                            disabled={!props.isAuthorized || !isNewGridAllocation}
                        >
                            <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                        </RadioButton>
                    </Column>
                </Row>
            </Column>
        );
    }

    const renderIsGrocerySortPathInput = (options) => {
        return (
            <Row key={options.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={options.formattedId}
                                              defaultMessage={options.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { options.inputOptions
                            .map(inputOption => renderIsGrocerySortPathInputOption(options, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

    const renderIsPSOnGridSortPathInputOption = (option, inputOption) => {
        return (
            <Column key={inputOption.id}>
                <Row spacing={"small"}>
                    <Column>
                        <RadioButton
                            checked={isPSOnGridSortPath === inputOption.value}
                            onChange={value => {
                                addToCommonFormData(
                                    SortGridAllocationCommonFormStates.IS_PS_ON_GRID_SORT_PATH,
                                    value
                                )
                            }
                            }
                            name={inputOption.id}
                            value={inputOption.value}
                            disabled={!props.isAuthorized || !isNewGridAllocation}
                        >
                            <FormattedMessage id={inputOption.formattedId} defaultMessage={inputOption.defaultLabel} />
                        </RadioButton>
                    </Column>
                </Row>
            </Column>
        );
    }

    const renderIsPSOnGridSortPathInput = (options) => {
        return (
            <Row key={options.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={options.formattedId}
                                              defaultMessage={options.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { options.inputOptions
                            .map(inputOption => renderIsPSOnGridSortPathInputOption(options, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

    const renderIsRushSortPathInput = (options) => {
        return (
            <Row key={options.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={options.formattedId}
                                              defaultMessage={options.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { options.inputOptions
                            .map(inputOption => renderIsRushSortPathInputOption(options, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

        const renderIsRush3hSortPathInput = (options) => {
        return (
            <Row key={options.id}>
                <Column spacing={"small"}>
                    <Row>
                        <Text type={"h100"}>
                            <FormattedMessage id={options.formattedId}
                                              defaultMessage={options.defaultLabel}/>
                        </Text>
                    </Row>
                    <Row spacing={"large"}>
                        { options.inputOptions
                            .map(inputOption => renderIsRush3hSortPathInputOption(options, inputOption))
                        }
                    </Row>
                </Column>
            </Row>
        )
    }

    return (
        <Row>
            <Column>
                <Row>
                    <Text type={"h200"}>
                        <FormattedMessage id="sortPaths.concurrentCycleInput"
                                          defaultMessage="Allocate a part of the sort grid" />
                    </Text>
                </Row>
                {
                    (FeatureConfigUtils.getIsPSOnGridSortPathEnabledStation() && isNewGridAllocation && !isRushSortPath && !isRush3hSortPath) && (
                        <>
                            {isPSOnGridSortPathInputs.map(input => renderIsPSOnGridSortPathInput(input))}
                        </>
                    )
                }
                {
                    (FeatureConfigUtils.getIsSSDGrocerySortPathEnabledStation() && isNewGridAllocation && !isRushSortPath && !isRush3hSortPath) && (
                        <>
                            {isGroceryBinSortPathInputs.map(input => renderIsGrocerySortPathInput(input))}
                        </>
                    )
                }
                { ((isGrocerySortPath && !isNewGridAllocation) || showTemperatureOption) && (
                        <>
                            {resourceTemperatureInputs.map(input => renderResourceTemperatureInput(input))}
                        </>
                    )
                }
                { FeatureConfigUtils.getIsSSDGroceryOVSortPathEnabledStation() &&
                    ((isGrocerySortPath && !isNewGridAllocation) || showTemperatureOption) && (
                    <>
                        {resourceVolumeTypeInputs.map(input => renderResourceVolumeTypeInput(input))}
                    </>
                )
                }
                {
                    ((FeatureConfigUtils.getIsRushSortPathEnabledStation() && !isRush3hSortPath && !isGrocerySortPath && !isPSOnGridSortPath && isNewGridAllocation) 
                        || (!isNewGridAllocation && isRushSortPath)) && (
                        <>
                            {isRushSortPathInputs.map(input => renderIsRushSortPathInput(input))}
                        </>
                    )
                }
                {
                    ((FeatureConfigUtils.getIsRushSortPathEnabledStation() && FeatureConfigUtils.getIsSSD3EnabledStation() && !isRushSortPath && !isGrocerySortPath && !isPSOnGridSortPath && isNewGridAllocation) 
                        || (!isNewGridAllocation && isRush3hSortPath)) && (
                        <>
                            {isRush3hSortPathInputs.map(input => renderIsRush3hSortPathInput(input))}
                        </>
                    )
                }
                {includedLocationInputs.map(input => renderIncludedLocationInput(input))}
                {renderExcludedLocationsInputForm() }
            </Column>
        </Row>
    );
}

export default SortGridAllocationPartitionInputForm;
